import React from 'react'
import styles from './PhotoHero.module.scss'
import logo from './../../../assets/images/logo.png';
import placeholderLogo from './../../../assets/svg/logo.svg';

/** The app's edge-to-edge PhotoHero: square photo, top and bottom scrims, white copy pinned to the bottom. */
export function PhotoHero(props: {coverUrl?: string | null; children?: React.ReactNode}) {
  return (
    <header className={styles.container}>
        <div className={styles.cover}>
            {props.coverUrl ?
                <img className={styles.photo} src={props.coverUrl} alt='' /> :
                <img className={styles.placeholderLogo} src={placeholderLogo as any} alt='' />}
        </div>
        <div className={styles.topScrim} />
        <div className={styles.bottomScrim} />
        <div className={styles.brand}>
            <img src={logo} alt='' />
            <span>Momap</span>
        </div>
        {props.children ? <div className={styles.copy}>{props.children}</div> : null}
    </header>
  )
}
